import React, { useEffect, useRef, useState } from 'react';
import './CartBanner.scss';
import CartBannerContent from './CartBannerContent/CartBannerContent';

const initialState = {
  isEntering: false,
  isExiting: false,
};

/**
 * Renders the banner component
 * @param {('cart'|'cookie')} type
 * @param {boolean} isVisible
 * @param {string} addedProduct
 * @param {string} message
 * @param {function} hideBanner
 * @returns {JSX.Element}
 * @constructor
 */
const CartBanner = ({
  banner: {
    reveal: { isVisible = false, addedProduct = '' },
  },
  hideBanner,
}) => {
  const [{ isEntering, isExiting }, setState] = useState(initialState);
  const wrapper = useRef();

  const clearState = () => {
    setState({ ...initialState });
    hideBanner();
  };

  useEffect(() => {
    setState({
      isEntering: true,
      isExiting: false,
    });
  }, [isEntering, isExiting]);

  isVisible &&
    setTimeout(() => {
      setState({
        isEntering: false,
        isExiting: true,
      });
      clearState();
    }, 3000);

  return isVisible ? (
    <div
      key={addedProduct}
      className={`c-cart-banner ${isEntering ? 'is-entering' : ''} ${
        isExiting ? 'is-exiting' : ''
      }`}
      ref={wrapper}
    >
      <div className="c-cart-banner__inner module-background-color-blue">
        <CartBannerContent
          setState={setState}
          clearState={clearState}
          message={`${addedProduct} was added to your cart.`}
        />
      </div>
    </div>
  ) : null;
};

export default CartBanner;
